import calls from './general/calls'
import superPanel from './general/superPanel'
import home from './general/home'
import people from './general/people'
import business from './general/business'
import talk from './general/talk'
import communicate from './general/communicate'
import events from './general/events'
import configure from './general/configure'
import connect from './general/connect'
import sequences from './general/sequences'
export default {
  ...calls,
  ...superPanel,
  ...home,
  ...connect,
  ...people,
  ...business,
  ...talk,
  ...communicate,
  ...events,
  ...configure,
  ...sequences
}
